/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useMemo } from "react";
import { translate } from "@/src/services/translations/translations";
import QuestionMarkIcon from "@/src/assets/icons/common/toggleable/IconQuestionmark";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import SellerIcon from "@/src/assets/icons/contract/toggleable/IconSeller";
import PhoneIcon from "@/src/assets/icons/contract/toggleable/IconPhone";
import InternetIcon from "@/src/assets/icons/contract/toggleable/IconInternet";

export const dataLeakContractFormDefinitions = {
  salesChannel: salesChannel,
};

function salesChannel(values: AbstractCase) {
  return useMemo(() => {
    return [
      {
        labelText: translate(`${values.name}.salesChannel.options.providerWebsite.label`, values),
        labelIcon: <InternetIcon />,
        labelIconActive: <InternetIcon active />,
        value: "providerWebsite",
      },
      {
        labelText: translate(`${values.name}.salesChannel.options.comparisonPortal.label`, values),
        labelIcon: <InternetIcon />,
        labelIconActive: <InternetIcon active />,
        value: "comparisonPortal",
      },
      {
        labelText: translate(`${values.name}.salesChannel.options.localStore.label`, values),
        labelIcon: <SellerIcon />,
        labelIconActive: <SellerIcon active />,
        value: "localStore",
      },
      {
        labelText: translate(`${values.name}.salesChannel.options.phone.label`, values),
        labelIcon: <PhoneIcon />,
        labelIconActive: <PhoneIcon active />,
        value: "phone",
      },
      {
        labelText: translate(`${values.name}.salesChannel.options.other.label`, values),
        labelIcon: <QuestionMarkIcon />,
        labelIconActive: <QuestionMarkIcon active />,
        value: "other",
      },
    ];
  }, []);
}
